module.exports = __webpack_public_path__ + "img/thumbler_padrao.61d1ff01.jpg";